import React, { useState, useEffect } from 'react';

import { Grid } from '@mui/material';

import ChatAppBody from './layout/ChatAppBody';
import StyledHeader from 'app/components/shared/StyledHeader';
import ChatPrimary from './ChatPrimary';
import ChatSecondary from './ChatSecondary';

const ChatAppContainer = () => {
  const [docWidth, setDocWidth] = useState(document.documentElement.clientWidth);

  const onResizeDoc = () => {
    setDocWidth(document.documentElement.clientWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', onResizeDoc);

    return () => {
      window.removeEventListener('resize', onResizeDoc);
    };
  }, []);

  // eslint-disable-next-line no-console
  console.log('docWidth', docWidth);

  return (
    <ChatAppBody
      sx={{
        // width: docWidth < 900 ? '100%' : 'calc(100% - 1000px)',
        width: '100%',
      }}
    >
      <StyledHeader
        data-test-id="template-shell-header"
        sx={{ paddingLeft: '1em' }}
      >
        Chat
      </StyledHeader>
      <Grid container sx={{ overflow: 'hidden' }}>
        {/* contacts list */}
        <Grid item sm={4} xs={12}>
          <ChatSecondary />
        </Grid>

        {/* messages */}
        <Grid item sm={8} xs={12}>
          <ChatPrimary />
        </Grid>
      </Grid>
    </ChatAppBody>
  );
};

export default ChatAppContainer;
